<template>
  <div class="productType">
    <div class="indexContainer">
      <el-divider class="indexTitle" v-if="val.title">
        <div class="indexTitleMain">
          <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br />
          <h4>{{val.summary}}</h4>
        </div>
      </el-divider>
      <div class="productCenterMain">
        <el-tabs type="border-card" v-model="activeName">
          <el-tab-pane :label="item.name" :name="'index' + index" v-for="(item, index) in productCenterList" :key="index">
            <el-row :gutter="20">
              <el-col :span="8" v-for="(list1, index2) in item.articles" :key="index2">
                <div class="newList" @click="rowClick(list1, index2)">
                  <div class="newListImg">
                    <img :src="list1.picUrl" :alt="list1.imgAlt">
                  </div>
                  <p class="text">{{list1.title}}</p>
                </div>
              </el-col>
            </el-row>
            <el-button v-if="item.linkUrl" class="more" round @click="handleShow(item.linkUrl)">{{item.moreText}}</el-button>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    val: {},
  },
  data() {
    return {
      activeName: 'index0',
      productCenterList: [],
      moduleId: '',
    }
  },
  created() {
    this.productCenterList = this.val.modules
    this.moduleId = this.val.moduleId
  },
  methods: {
    handleShow(url) {
      window.open(url, '_blank')
    },
    rowClick(row, index) {
      if (row.isLink && row.linkUrl) {
        window.open(row.linkUrl, '_blank')
        return
      }
      if (Number(row.type) === 0) {
        let routerPath = this.$router.resolve({
          name: 'ARTICLEDETAIL',
          query: {
            languageId: this.$route.query.languageId,
            model: this.$route.query.model,
            moduleId: this.moduleId,
            modelId: this.$route.query.id,
            level: this.$route.query.level,
            type: this.$route.query.type,
            id: row.id,
          },
        })
        window.open(routerPath.href, '_blank')
      } else if (Number(row.type) === 1) {
        let item = this.handleData()
        this.$refs.pic.open(item, index)
      } else if (Number(row.type) === 2) {
        this.$refs.video.open(row)
      }
    },
  },
  watch: {
    val(val) {
      this.productCenterList = this.val.modules
    },
  },
}
</script>
<style lang="less" scoped>
.productType {
  .productCenterMain {
    padding-top: 30px;
    /deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
      color: #d11a2e;
    }
    /deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
      color: #d11a2e;
    }
    /deep/.el-tabs__nav-wrap.is-scrollable {
      padding: 0 30px;
    }
    /deep/.el-tabs__nav-next,
    /deep/.el-tabs__nav-prev {
      width: 30px;
      display: inline-block;
    }
    /deep/.el-icon-arrow-left,
    /deep/.el-icon-arrow-right {
      font-size: 16px;
    }

    .more {
      padding: 10px 50px;
      color: #d11a2e;
      box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
      margin-bottom: 12px;
      margin-top: 20px;
    }
    .more:hover {
      background: #f7f7f7;
      border: 1px solid #dcdfe6;
    }
    .el-button:hover {
      border: 1px solid #eee;
      color: #d11a2e;
    }
    .el-button:focus {
      color: #d11a2e;
      border-color: #ccc;
      background-color: #f7f7f7;
    }
  }
  .newList {
    border-radius: 4px;
    background: #f7f7f7;
    display: inline-block;
    width: 100%;
    overflow: hidden;
    margin-top: 10px;
    cursor: pointer;
    .newListImg {
      width: 100%;
      height: 102px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        display: block;
      }
      img:hover {
        transform: scale(1.2);
        transition: all 3s;
      }
    }
    p {
      line-height: 24px;
      text-align: left;
      height: 48px;
      overflow: hidden;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      margin: 5px 10px 10px;
      padding: 0;
      font-weight: bold;
    }
  }
  .newList:hover {
    p {
      color: #d11a2e;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    .newList {
      .newListImg {
        height: 132px;
      }
      p {
        font-weight: normal;
      }
    }
  }
  @media (min-width: 1024px) and (max-width: 1200px) {
    .newList {
      .newListImg {
        height: 152px;
      }
      p {
        font-weight: normal;
      }
    }
  }
  @media only screen and (min-width: 1200px) {
    .newList {
      .newListImg {
        height: 172px;
      }
      p {
        font-weight: normal;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch19.vue